module.exports = __webpack_public_path__ + "static/media/recommendation-frequently-bought-together.b737ac03.png";